module.exports = __webpack_public_path__ + "img/help.836fcaf8.png";